<template>
  <div class="flex items-center justify-between w-full">

    <h2> Appareils : {{ NewDevices.rc.length }}</h2>

    <div class="flex items-center">
      <slot></slot>
    </div>
  </div>

  <p class="text-[#b1b1b1] text-xs mt-2">
    {{ $e(`Le numéro de série de votre RC n'a pas été reconnu ou n'est pas enregistré dans le système.`) }}<br>
    {{ $e(`Veuillez le sélectionner dans la liste ci-dessous ou l'ajouter en vous rendant sur l'application web de
    FlyingHub.`) }}
  </p>

  <div class="mt-5 flex overflow-x-auto max-h-dvh pb-4">

    <template v-for="(device, index) in NewDevices.rc" :key="index">
      <div @click.prevent="$emit('response', device)"
        class=" cursor-pointer flex flex-col items-center justify-between min-w-[275px] max-h-[275px] min-h-[200px]  bg-g1 mr-2 p-2 overflow-hidden">
        <div class="flex flex-col items-center">
          <h3>
            {{ device.dev_name }}
            {{ getDroneName(device) }}
          </h3>
          <p class="text-g3 mt-1 font-mono text-xs w-max break-keep">
            {{ device.dev_sn }}
            {{ getDroneSn(device) }}
          </p>
          <div class="flex">
            <img :src="`/assets/images/device/${getImage(device)}`" class="h-[90px] p-1 !pb-0" alt="">
            <div v-html="getDroneImage(device)"></div>
          </div>
        </div>

        <div class="flex items-center flex-col justify-between w-full text-xs">
          <p>{{ device.sit_name == getENV_DEVICE_SITE_GARAGE() ? getENV_DEVICE_SITE_GARAGE_NAME() : device.sit_name }}</p>
          <p class="truncate break-all w-full text-g3 w-[200px]">{{ device_type(device.det_id) }}</p>
        </div>
      </div>
    </template>
  </div>

</template>

<script>
import { ref } from "vue";

export default {
  name: "Pilot_Devices",
  emits: ['response'],
  props: {
    NewDevices: Object,
    devices: Array
  },
  setup() {
  },


  methods: {
    getImage(device) {
      if (device?.det_id == undefined) return "default.png";
      return this.$root.device_image.hasOwnProperty(device.det_id)
        ? this.$root.device_image[device.det_id]
        : "default.png";
    },

    getENV_DEVICE_SITE_GARAGE() {
      return ENV.DEVICE_SITE_GARAGE
    },

    getENV_DEVICE_SITE_GARAGE_NAME() {
      return ENV.DEVICE_SITE_GARAGE_NAME
    },


    device_type(det_id) {
      return this.$root.device_type.hasOwnProperty(det_id)
        ? this.$root.device_type[det_id]
        : "Inconnu";
    },


    getTimestampDJI(timestamp) {
      if (timestamp == null) return ENV.NO_DATA;
      return deviceDate(timestamp);
    },

    addOnDockOrRc(device, type) {
      this.searchOn(device, this.NewDevices.dock, type);
      this.searchOn(device, this.NewDevices.rc, type);
    },

    searchOn(device, array, type) {
      array.forEach((element) => {
        if (element.dev_family.drone_dev_id == device.dev_id) {
          element[type] = device;
        }
      });
    },

    getDrone(device) {
      return this.NewDevices.drone.find(
        (d) => d.dev_id == device.dev_family.drone_dev_id
      );
    },

    getDroneName(device) {
      if (device?.dev_family?.drone_dev_id == undefined) return "";
      let drone = this.getDrone(device);

      return drone != undefined ? ` - ${drone.dev_name}` : "";
    },

    getDroneSn(device) {
      if (device?.dev_family?.drone_dev_id == undefined) return "";
      let drone = this.getDrone(device);

      return drone != undefined ? ` / ${drone.dev_sn}` : "";
    },

    getDroneImage(device) {
      if (device?.dev_family?.drone_dev_id == undefined) return "";
      let drone = this.getDrone(device);

      if (drone != undefined) {
        return `<img src="/assets/images/device/${this.getImage(drone)}" class="h-[90px] p-1 !pb-0" alt="">`;
      }
    },
  },
};
</script>
